export const INFO_LIST = ["DE", "EN", "ES", "FR", "IT", "KO", "XX", "OO", "JA"].map((name: string) => ({ id: name, name }));
